import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../../theme-context';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
    tryToDeleteCards,
    tryToGetCards,
} from '../../../store/brokers/partners/history-chats/historyChatsSlice';
import Table from '../../../shared/table';
import { ICards } from '../../../interfaces/cards/ICards';
import Button from '../../../shared/button';
import EmployeeUpdatedNews from './EmployeeUpdatedNews';

const tableColumns = ['Title', 'Subtitle', 'Image', 'Color', 'Action'];

const EmployeeUpdatedNewsList = () => {
    const [cardToEdit, setCardToEdit] = useState<ICards>();
    const cardIsLoading = useAppSelector(
        (state) => state.history.cardIsLoading,
    );
    const [cards, setCards] = useState<ICards[]>([]);
    const dispatch = useAppDispatch();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const onClickGoBack = () => {
		if (cardToEdit) {
			setCardToEdit(undefined)
		} else {
			navigate('/insights');
		}
    };

    const getCards = async () => {
        try {
            const response = await dispatch(tryToGetCards()).unwrap();
            setCards(response);
        } catch (e) {
            console.error({ e });
        }
    };

    useEffect(() => {
        getCards();
    }, []);

    const handleDelete = async (id: string) => {
        try {
            await dispatch(tryToDeleteCards(id)).unwrap();
            getCards();
        } catch (e) {
            console.error({ e });
        }
    };

    const handleEdit = (id: string) => {
        const currentCard = cards.find((card) => card._id === id);
        setCardToEdit(currentCard);
    };

    return (
        <div className="min-h-[95vh]">
            <div
                className="flex flex-row items-center cursor-pointer hover:opacity-80 mt-3 mb-8"
                onClick={onClickGoBack}>
                <img
                    src={
                        theme === 'dark'
                            ? '/assets/shared/arrow-back-white.svg'
                            : '/assets/shared/arrow-back.svg'
                    }
                    className={'object-contain w-[20px] mr-2'}
                />
                <p className="dark:text-primary-dark">Employee updated news</p>
            </div>
            <div className="my-8">
                <EmployeeUpdatedNews
                    getCards={getCards}
                    cardToEdit={cardToEdit}
					onClickGoBack={onClickGoBack}
                />
            </div>
            {cardToEdit ? (
                <></>
            ) : (
                <>
                    <hr />
                    <Table
                        columns={tableColumns}
                        hidePagination={true}
                        headStyle="!bg-[#000000] !text-white">
                        {cardIsLoading && <p>Loading..</p>}
                        {cards?.length > 0 &&
                            cards?.map((row: ICards, idx: number) => {
                                return (
                                    <tr
                                        key={idx}
                                        className="bg-white border-b hover:bg-gray-50">
                                        <td className="px-6 py-4">
                                            {row.title}
                                        </td>
                                        <td className="px-6 py-4">
                                            {row.subtitle}
                                        </td>
                                        <td className="px-6 py-4">
                                            <img
                                                alt={row.title}
                                                height={40}
                                                className="h-10"
                                                src={row.image}
                                            />
                                        </td>
                                        <td className="px-6 py-4">
                                            <span style={{ color: row.color }}>
                                                {row.color}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <Button
                                                label="Edit"
                                                className="mr-4"
                                                onClickButton={() =>
                                                    handleEdit(row._id)
                                                }
                                            />
                                            <Button
                                                label="Delete"
                                                onClickButton={() =>
                                                    handleDelete(row._id)
                                                }
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                    </Table>
                </>
            )}
        </div>
    );
};

export default EmployeeUpdatedNewsList;
